module.exports = __webpack_public_path__ + "img/manualhandling.e1b72222.jpg";